import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition"
import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";
import RevolverWinTransitions from "./revolver-win-transitions";
import { CenterPivot, Group } from "slotworks/graphics/pixi/group";
import Logger = require("js-logger");

export default class BonusTransitions extends RevolverWinTransitions {

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.resetEverything();
            this.zoomInStacks(100, 4, 4).execute();            
            const offsetX = RevolverWinTransitions.glowContainer.x * 0.05;
            RevolverWinTransitions.glowContainer.x += offsetX;
            RevolverWinTransitions.rainbowContainer.x += offsetX;
            RevolverWinTransitions.setOrientationChange();
            resolve(null);     
        });
    }

    public out(): Contract<void> {
        return new Contract((resolve) => {    
            RevolverWinTransitions.removeOrientationChange();  
            resolve(null);                            
        });
    }

}